<template>
  <div :style="{ 'width': clientWidth + 'px', 'height': clientHeight + 'px' }" class="ResetPassword">
    <div class="layer">
      <div class="content">
        <div class="Tit">重置密码</div>
        <div class="int password">
          <el-input type="password" class="password" v-model="oldPassword" placeholder="请输入密码"/>
        </div>
        <div class="int password">
          <el-input type="password" class="password" v-model="password" placeholder="请输入密码"/>
        </div>
        <div class="int password">
          <el-input type="password" class="password" v-model="againPassword" placeholder="请输入再次密码"/>
        </div>
        <div class="click">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        clientWidth: '',
        clientHeight: '',
        oldPassword: '',
        password: '',
        againPassword: ''
      }
    },
    mounted () {
      this.clientWidth = document.documentElement.clientWidth
      this.clientHeight = document.documentElement.clientHeight
      window.onresize = function () {
        this.clientWidth = document.documentElement.clientWidth
        this.clientHeight = document.documentElement.clientHeight
      }
    },
    created () {

    },
    methods: {
      handleClick () { // 验证数字
        console.log(this.phone)
        this.phone = this.phone.replace(/[^\w]/g, '')
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .ResetPassword {
    background: url("bg.png") no-repeat center center;

    .layer {
      width: 993px;
      height: 500px;
      position: fixed;
      background: url("layer.png") no-repeat center center;
      left: 50%;
      top: 50%;
      margin: -250px 0px 0px -496.5px;

      .content {
        width: 300px;
        overflow: hidden;
        margin-left: 530px;

        .Tit {
          width: 300px;
          font-size: 20px;
          text-align: center;
          font-weight: bold;
          margin: 90px auto 40px;
        }

        .int {
          width: 300px;
          height: 44px;
          margin: 10px auto 0;
          position: relative;

          .phone {
            input {
              background: url("phone.png") no-repeat 3% 50%;
              background-size: 35px 35px;
            }
          }

          .password {
            input {
              background: url("password.png") no-repeat 3% 50%;
              background-size: 35px 35px;
            }
          }

          .code {
            input {
              background: url("code.png") no-repeat 3% 50%;
              background-size: 35px 35px;
            }
          }

          input {
            width: 298px;
            height: 42px;
            border: 1px solid #c6c6c6;
            color: #c6c6c6;
            line-height: 42px;
            padding: 0;
            text-indent: 40px;
          }

          span {
            color: #fc8375;
            position: absolute;
            top: 0;
            right: 10px;
            cursor: pointer;
            line-height: 44px;
          }
        }

        .click {
          width: 300px;
          height: 45px;
          background-color: #ff8484;
          text-align: center;
          line-height: 45px;
          color: #fff;
          border-radius: 10px;
          cursor: pointer;
          margin: 36px auto 0;

          &:hover {
            background-color: #fc9797;
          }

          &:active {
            width: 298px;
            height: 43px;
            border: 1px solid #ff8484;
          }
        }

        .Txt {
          width: 300px;
          text-align: right;
          color: #ff8484;
          margin: 10px auto 0;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword/ResetPassword.vue